import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as state from '../../../../../state'
import * as variable from '../variable'

@ngCore.Component({
  imports: [variable.Component],
  selector: 'atn-variables',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.variableOverrides.Feature} */
  public readonly variablesFeature = ngCore.inject(
    state.variableOverrides.Feature,
  )
  public readonly schemaFeature = ngCore.inject(state.dms.schema.Feature)

  /**
   * Update variable value in state
   */
  public valueChangeHandler(
    value: ents.core.dms.data.Value,
    definition: state.variableOverrides.models.Definition,
  ): void {
    const holder = this.variablesFeature.selectors.focused.asSignal()
    const schema = this.schemaFeature.selectors.schema.asSignal()
    if (holder) {
      const type = schema.tryGetType(definition.type)
      this.variablesFeature.actions.updateValue
        .from('MosaicVariableComponent.ValueChanged')
        .dispatch({
          holder,
          value: type ? ents.core.common.value.Raw.cast(value, type) : value,
          variableId: definition.id,
        })
    }
  }
}
